var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{staticClass:"main-loginPage",staticStyle:{"background":"url('../../static/img/loginimg.jpg') no-repeat center center","background-size":"cover"},attrs:{"login-screen":""}},[_c('Login',{attrs:{"has-restore-pass":true,"has-remember-me":true,"has-need-help":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }